<nz-row nzGutter="24">
  <nz-col [nzSm]="24">
    <r-widget-control [control]="firstnameControl">
      <nz-input-number
        [name]="config.name"
        [nzPlaceHolder]="config.placeholder"
        [(ngModel)]="config.value"
        (ngModelChange)="onChange($event)"
        [nzPrecision]="config.precision"
        nzPrecisionMode="cut"
        [nzMin]="config.min"
        [nzMax]="config.max"
        [nzStep]="config.step"
        style="width: 100%"
        ngDefaultControl
        #firstnameControl="ngModel"
        [required]="config.required"
        [disabled]="config.disabled"
      ></nz-input-number>
    </r-widget-control>
  </nz-col>
  <nz-col [nzSm]="24" *ngIf="config.ruleType === ruleType.Limit">
    <app-limit-display [config]="config"> </app-limit-display>
  </nz-col>
  <nz-col [nzSm]="24" *ngIf="config.ruleType === ruleType.Effective && config.effective.length">
    <app-effective-display [config]="config"> </app-effective-display>
  </nz-col>
</nz-row>
